import React from 'react';
import { Col, Card } from 'antd';

import { TableCustom } from './TableCustom';
import * as S from './styles';

export function AtendimentoExterno() {
  return <S.Wrapper>
    <Col>
      <Card>
        <TableCustom
          dateRange
        />
      </Card>
    </Col>
         </S.Wrapper>;
}
